import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import 'video.js/dist/video-js.min.css'
import ElementUI from 'element-ui'
import '@/styles/element-variables.scss'
import moment from 'moment'
import '@/styles/index.scss' // global css
import _ from 'lodash'
import animated from 'animate.css' // npm install animate.css --save安装，再引入
import '@/components/components.js'
import Decimal from 'decimal.js'
import '@/assets/font/font.css'

import * as echarts from 'echarts'
import 'echarts-gl'

import 'amfe-flexible'

Vue.config.productionTip = false // 3d图表库

Vue.prototype.$echarts = echarts

Vue.use(animated)

Vue.prototype._ = _
Vue.prototype.Decimal = Decimal
Vue.prototype.$moment = moment // 赋值使用
Vue.prototype.$bus = new Vue()
import App from './App'
import store from './store'
import router from './router'
import '@/icons' // icon
import '@/permission' // permission control
// set ElementUI lang to EN
Vue.use(ElementUI)

import DictPlugin from '@/utils/dict'
Vue.use(DictPlugin)

Vue.config.productionTip = false
console.log('*******************************************')
console.log('VERSIOM_CODE=' + process.env.VUE_APP_VERSION_CODE)
console.log('BUILD_DATE=' + process.env.VUE_APP_BUILD_DATE)
console.log('*******************************************')

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
